// Import necessary Material-UI components
import { Box } from "@mui/material";
// Import custom functions, components and hooks
import { QualityReportGroupDetails } from "./QualityReportGroupDetails.component";
// Import custom CSS
import "./qualityReportGroup.css";
// Import necessary Kendo-React-PDF component

// Import hook for destructuring data
import { useHistoricalReportData } from "./hooks/useHistoricalReportData.hook";
import { useHistoricalPDFLink } from "./hooks/useHistoricalPDFLink.hook";

export function HistoricalReportDetails({ rowData }) {
  // Destructing data and creating groups via hook
  const { ids, dataGroups, fullPath } = useHistoricalReportData(rowData);
  // const encodedPDFLink = encodeURIComponent(fullPath);
  // console.log(encodedPDFLink);
  const pdfURL = useHistoricalPDFLink(fullPath);
  return (
    <Box height={"100%"}>
      {/* Content within PDFExport component */}
      <div className="group">
        <b>Historical Report Details</b>
        <QualityReportGroupDetails data={ids} />
      </div>

      {/* Mapping through data groups to display various sections */}
      {dataGroups.map((item, index) => {
        return (
          item.data && (
            <div className="group" key={index}>
              <b>{item.title}</b>
              <QualityReportGroupDetails data={item.data} />
            </div>
          )
        );
      })}

      {pdfURL && (
        <embed
          src={pdfURL}
          type="application/pdf"
          width="100%"
          height="1300px"
        />
      )}
    </Box>
  );
}
